import { IconButton, Menu, MenuItem, Stack, Tooltip } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import * as React from "react";
import {
    EditModes,
    useTemplateViewEdit,
} from "src/components/providers/template-view-edit-provider";
import styled from "styled-components";

const AddButton = styled(IconButton)`
    top: 0;
    right: 0;
    margin-top: -10px;
    margin-right: -10px;
    background-color: #333333;
    &:hover {
        background-color: #333333;
        outline: 2px dashed #474747;
    }
`;

const TemplateAddRow = ({
    top,
    position,
    templateIndex,
}: {
    top: boolean;
    position: number;
    templateIndex: number;
}) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const { editView } = useTemplateViewEdit();

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleSelection = (selection: EditModes.addChartRow | EditModes.addNumbersRow) => () => {
        if (editView) {
            editView({
                templateIndex,
                rowIndex: position,
                editMode: selection,
            });
        }

        setAnchorEl(null);
    };

    return (
        <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
                position: "absolute",
                right: 0,
                zIndex: 102,
                ...(top ? { marginTop: "-16px" } : { marginBottom: "-23px" }),
                ...(top ? { top: 0 } : { bottom: 0 }),
                width: "100%",
            }}
            direction="row"
        >
            <Tooltip title="Add Row">
                <AddButton
                    onClick={handleClick}
                    aria-label="add row"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                >
                    <AddCircleOutlineIcon />
                </AddButton>
            </Tooltip>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                MenuListProps={{
                    "aria-labelledby": "basic-button",
                }}
            >
                <MenuItem onClick={handleSelection(EditModes.addChartRow)}>Add Charts Row</MenuItem>
                <MenuItem onClick={handleSelection(EditModes.addNumbersRow)}>
                    Add Numbers Row
                </MenuItem>
            </Menu>
        </Stack>
    );
};

export default TemplateAddRow;
